<template>
  <div>
    <v-container fluid grid-list-md class="padding_10">
      <v-expansion-panel class="mb-4">
        <v-expansion-panel-content>
          <template v-slot:header>
            <div>Filters</div>
          </template>
          <v-layout row wrap style="padding: 0px 10px 0px 10px; align-content: center;">
            <v-flex sm12 md6 lg3>
              <v-select
                  solo flat
                  v-model="filters.criticality_level"
                  :loading="loaders.criticality_levels"
                  :items="criticality_levels"
                  item-text="name"
                  item-value="id"
                  label="Criticality Level"
              ></v-select>
            </v-flex>
            <v-flex sm12 md6 lg3>
              <v-select
                  solo flat
                  v-model="filters.issue_module"
                  :items="issue_modules"
                  item-text="name"
                  item-value="id"
                  label="Issue Module"
              ></v-select>
            </v-flex>
            <v-flex sm12 md12 lg2 style="display: flex; justify-content: center; margin-top: -17px;">
              <v-btn @click="applyFilters" color="primary" class="mt-3">
                Filter
              </v-btn>
            </v-flex>
          </v-layout>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-layout row wrap class="table_opacity_8">
        <v-flex xs12>
          <v-data-table
              no-results-text="Loading... Please wait"
              :headers="headers"
              :items="feedback_list"
              item-key="id"
              :pagination.sync="pagination"
              :loading="loaders.feedback_list_loader"
              :total-items="total_items"
              :rows-per-page-items="[10, 20, 50, 100]">
            <template slot="items" slot-scope="props">
              <td>
                <router-link :to="{ name: 'feedback', params: { id: props.item.id }}">
                  {{ props.item.first_name }}
                </router-link>
              </td>
              <td v-if="props.item.email_id">{{ props.item.email_id }}</td>
              <td v-else>{{ " - " }}</td>

              <td v-if="props.item.criticality">{{ props.item.criticality }}</td>
              <td v-else>{{ " - " }}</td>

              <td style="width:30%" v-if="props.item.feedback.length < 30">{{ props.item.feedback
                }}</td>
              <td style="width:30%" v-else-if="props.item.feedback">{{ props.item.feedback }}</td>
              <td v-else>{{ " - " }}</td>


              <td v-if="props.item.is_reply == 1"><v-chip label style="font-size: 12px;
                        border-radius: 5px;" small color="#C8E6C9" text-color="#1B5E20">{{ "Success" }}</v-chip> </td>
              <td v-else-if="props.item.is_reply == 0"><v-chip style="font-size: 12px;
                        border-radius: 5px;" label small color="rgba(255, 82, 82, 0.24)" text-color="#ff5252">{{
                  "Pending" }}</v-chip></td>
              <td v-else>{{ " - " }}</td>

              <td v-if="props.item.created_at">{{ props.item.created_at | appDateTimeFormat }}</td>
              <td v-else>{{ " - " }}</td>

            </template>
            <template slot="no-data">
              <v-layout
                  row
                  wrap
                  justify-center
                  class="text-xs-center"
                  v-if="loaders.feedback_list_loader"
              >
                Loading... Please wait
              </v-layout>
              <v-layout row wrap justify-center class="text-xs-center" v-else>
                No data available
              </v-layout>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>

    <v-snackbar v-model="snackbar.display" :color="snackbar.color" :top="snackbar.top" :bottom="snackbar.bottom"
                :left="snackbar.left" :right="snackbar.right" :timeout="snackbar.timeout">
      {{ snackbar.message }}
      <v-btn
          text
          dark
          @click="snackbar.display = false"
      >
        <v-icon
            right
            color="white"
        >
          close
        </v-icon>
      </v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "index",
  data: () => {
    return {
      headers: [
        {
          text: "User Name",
          value: "user name",
          align: "left",
          sortable: false,
        },
        {
          text: "Email-ID",
          value: "email-id",
          sortable: false,
        },
        {
          text: "Criticality",
          value: "criticality",
          sortable: false,
        },
        {
          text: "FeedBack",
          value: "feedback",
          sortable: false,
        },
        {
          text: "Reply Status",
          value: "is_reply",
          sortable: false,
        },
        {
          text: "Updated At",
          value: "updated_at",
          sortable: false,
        },
      ],
      loaders: {
        feedback_list_loader: false,
        criticality_levels: false,
      },
      feedback_list: [],
      total_items: 0,
      criticality_levels: [],
      issue_modules: [{"id": "all", "name": "All"}, {"id": "live_location", "name": "Live Location"}],
      pagination: {sortBy: "updated_at", descending: true, rowsPerPage: 10},
      filters: {
        criticality_level: "",
        issue_module: "all",
      },
      snackbar: {
        message: '',
        display: false,
        color: 'black',
        top: true,
        right: true,
        bottom: false,
        left: false,
        timeout: 2000
      },
    };
  },
  watch: {
    pagination: {
      handler() {
        this.getList();
      },
    },
    // search_title: {
    //   handler(newVal) {
    //     if (newVal != null && newVal.length > 3) {
    //       this.getTitlesList(newVal);
    //     }
    //   },
    // },
    // "filters.title": {
    //   handler(value) {
    //     if (value == undefined) {
    //       this.filters.title = "";
    //       this.getList();
    //     }
    //   },
    // },
  },
  methods: {
    // filter(e) {
    //   this.filters.Published = false;
    //   this.filters.Draft = e;

    //   this.getList();
    // },
    // filterPublished(e) {
    //   this.filters.Draft = false;
    //   this.filters.Published = e;
    //   this.getList();
    // },
    // searchByTitle() {
    //   this.getList();
    // },
    getList: function () {
      this.loaders.feedback_list_loader = true;
      this.pagination.filters = Object.assign({}, this.filters);
      axios
          .get(`${process.env.VUE_APP_API_URL}/api/v1/feedback-list`, {
            headers: this.$headers,
            params: this.pagination,
          })
          .then((response) => {
            if (response.data.status == 1) {
              this.feedback_list = response.data.feedbacks.data;
              this.total_items = response.data.feedbacks.total;
              this.loaders.feedback_list_loader = false;
            }
          })
          .catch((error) => {
            // this.snack_bar.message = "Error Occured";
            // this.snack_bar.show;
            this.loaders.feedback_list_loader = false;
          })
          .finally(() => {
            {
              this.loaders.feedback_list_loader = false;
            }
          });
      this.is_loading = false;
    },
    getLevelList() {
      this.loaders.criticality_levels = true
      axios.get(`${process.env.VUE_APP_API_URL}/api/v1/criticality-levels`, {headers: this.$headers})
          .then((response) => {
            if (response.data.status == 1) {
              this.criticality_levels = response.data.levels
              this.filters.criticality_level = this.criticality_levels[0].id;
            }
          })
          .finally(() => {
            this.loaders.criticality_levels = false
          })
    },
    applyFilters() {
      this.getList()
    }
  },
  mounted() {
    this.getLevelList();
    if (this.$route.params.message) {
      this.snackbar.display = true;
      this.snackbar.message = this.$route.params.message;
    }
    // console.log(this.$store.getters.get_user);
  },
};
</script>

<style>
.add_notification {
  background: linear-gradient(90deg, #ff5e5c 0%, #ff9233 100%);
}
</style>

